import Mailcheck from "mailcheck";

class Mail {
  constructor (email) {
    this.mailData = Mailcheck.splitEmail(email);
    this.changed = false;
  }

  getMail() {
    return this.mailData.address + '@' + this.mailData.domain;
  }

  /**
   * transforms the mail
   */
  transform(topLevelDomain) {
    let email = this.getMail();
    const indexOfTopLevel = email.indexOf(topLevelDomain);

    if (email.indexOf('.' + topLevelDomain) === -1 && indexOfTopLevel === (email.length - topLevelDomain.length)) {
      email = email.substring(0, indexOfTopLevel) + '.' + topLevelDomain;
      this.mailData = Mailcheck.splitEmail(email);
      this.changed = true;
    }
  }
}

export default Mail;